module.exports = __webpack_public_path__ + "img/NW15.573255c2.jpg";